let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("57ZMI")).then(() => parcelRequire('5pAGJ'));